import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Input, Label, Button } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import { __ } from '../../Utils';
import { connect } from '../../Store';

const StyledInput = styled(Input)`
  max-width: ${rem(80)};
  height: ${rem(32)};
  margin-left: ${rem(20)};
`;

const InputRow = styled.div`
  max-width: ${rem(180)};
  display: flex;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${rem(8)};
  padding-right: ${rem(22)};
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // border-bottom: 1px solid #eee;
  padding: ${rem(1)};
`;

const Wrapper = styled.div`
  min-width: ${rem(300)};
`;

const Title = styled.div`
  display: flex;
  justify-content: center;
  font-size: ${rem(20)};
  margin-bottom: ${rem(30)};
`;

const StyledLabel = styled(Label)`
  width: ${rem(40)};
  text-align: end;
  display: flex;
  justify-content: flex-end;
  margin-right: ${rem(12)};
`;

const Pcs = styled.div`
  min-width: ${rem(50)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-left: ${rem(16)};
`;

class ProductQuantitySelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pcs: '',
      pal: '',
      box: '',
      pcsDisabled: false,
      palDisabled: false,
      boxDisabled: false,
      boxPcs: 0,
      palPcs: 0,
    };
  }

  componentDidMount() {
    const { items, defaultQuantity } = this.props;
    const palPcs =
      (items.find(i => i.Unit === 'PAL') &&
        items.find(i => i.Unit === 'PAL').Qty_per_Unit_of_Measure) ||
      0;
    const boxPcs =
      (items.find(i => i.Unit === 'BOX') &&
        items.find(i => i.Unit === 'BOX').Qty_per_Unit_of_Measure) ||
      0;

    this.setState(
      {
        palPcs,
        boxPcs,
      },
      () => {
        if (defaultQuantity > 0) {
          this.handleChange(`${defaultQuantity}`, 'pcs');
        }
      },
    );
  }

  componentWillReceiveProps(nextProps) {
    const { items: oldItems } = this.props;
    const { items } = nextProps;

    const prevBoxPcs =
      (oldItems.find(i => i.Unit === 'BOX') &&
        oldItems.find(i => i.Unit === 'BOX').Qty_per_Unit_of_Measure) ||
      undefined;

    const prevPalPcs =
      (oldItems.find(i => i.Unit === 'PAL') &&
        oldItems.find(i => i.Unit === 'PAL').unit) ||
      undefined;

    const palPcs =
      (items.find(i => i.Unit === 'PAL') &&
        items.find(i => i.Unit === 'PAL').Qty_per_Unit_of_Measure) ||
      0;
    const boxPcs =
      (items.find(i => i.Unit === 'BOX') &&
        items.find(i => i.Unit === 'BOX').Qty_per_Unit_of_Measure) ||
      0;

    if (
      (prevPalPcs && prevPalPcs !== palPcs) ||
      (prevBoxPcs && prevBoxPcs !== boxPcs)
    ) {
      this.setState({
        pcs: '',
        pal: '',
        box: '',
        pcsDisabled: false,
        palDisabled: false,
        boxDisabled: false,
        palPcs,
        boxPcs,
      });
    } else {
      if (nextProps.variantId && this.props.variantId !== nextProps.variantId) {
        this.props.changeListener(this.state.pcs);
      }
      this.setState({
        palPcs,
        boxPcs,
      });
    }
  }

  handleChange(value, type) {
    let { pcs, pal, box, pcsDisabled, palDisabled, boxDisabled } = this.state;

    const { palPcs, boxPcs } = this.state;
    if (Number(value) > 0 && value.length > 0) {
      if (type === 'pcs') {
        pcs = value;
        pal = Number(pcs / palPcs).toFixed(2);
        box = Number(pcs / boxPcs).toFixed(2);
        palDisabled = true;
        boxDisabled = true;
      } else if (type === 'pal') {
        pal = value;
        pcs = palPcs * value;
        box = Number(pcs / boxPcs).toFixed(2);
        pcsDisabled = true;
        boxDisabled = true;
      } else if (type === 'box') {
        box = value;
        pcs = boxPcs * value;
        pal = Number(pcs / palPcs).toFixed(2);
        pcsDisabled = true;
        palDisabled = true;
      }
    } else if (value.length === 0 || Number(value) === 0) {
      palDisabled = false;
      boxDisabled = false;
      pcsDisabled = false;
      pal = '';
      box = '';
      pcs = '';
    }

    this.setState(
      {
        pcs,
        pal,
        box,
        pcsDisabled,
        palDisabled,
        boxDisabled,
      },
      () => this.props.changeListener(Number(pcs)),
    );
  }

  render() {
    const { items, onSubmit, showTitle, showButton } = this.props;
    const {
      pcs,
      pal,
      box,
      pcsDisabled,
      palDisabled,
      boxDisabled,
      palPcs,
      boxPcs,
    } = this.state;

    return (
      <Wrapper>
        {showTitle && (
          <Title style={{ marginTop: rem(16) }}>
            {__('Zvolte počet kusov')}
          </Title>
        )}

        <Row>
          <StyledLabel>{__('Kusy')}</StyledLabel>
          <InputRow>
            <StyledInput
              onKeyDown={e => this.props.handleKeyDown(e, pcs)}
              style={{ height: rem(32) }}
              type="number"
              value={pcs}
              onChange={e => this.handleChange(e.target.value, 'pcs')}
              placeholder={__('ks')}
              disabled={pcsDisabled}
            />
            <Pcs />
          </InputRow>
        </Row>

        {items.find(i => i.Unit === 'BOX') && (
          <Row>
            <StyledLabel>{__('Balenia')}</StyledLabel>
            <InputRow>
              <StyledInput
                onKeyDown={e => this.props.handleKeyDown(e, pcs)}
                style={{ height: rem(32) }}
                type="number"
                value={box}
                onChange={e => this.handleChange(e.target.value, 'box')}
                placeholder={__('ks')}
                disabled={boxDisabled}
              />
              <Pcs>{`(${boxPcs} ${__(`ks`)})`}</Pcs>
            </InputRow>
          </Row>
        )}

        {items.find(i => i.Unit === 'PAL') && (
          <Row>
            <StyledLabel>{__('Palety')}</StyledLabel>
            <InputRow>
              <StyledInput
                onKeyDown={e => this.props.handleKeyDown(e, pcs)}
                style={{ height: rem(32) }}
                type="number"
                value={pal}
                onChange={e => this.handleChange(e.target.value, 'pal')}
                placeholder={__('ks')}
                disabled={palDisabled}
              />
              <Pcs>{`(${palPcs} ${__(`ks`)})`}</Pcs>
            </InputRow>
          </Row>
        )}

        {showButton && (
          <ButtonRow>
            <Button
              onClick={() => onSubmit(Number(pcs))}
              disabled={pcs <= 0}
              loading={this.props.loading}
              primary
            >{`${__('Vložiť do košíka ')} ${
              pcs > 0 ? `${pcs} ${__('ks')}` : ``
            }`}</Button>
          </ButtonRow>
        )}
      </Wrapper>
    );
  }
}

ProductQuantitySelect.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onSubmit: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func,
  showTitle: PropTypes.bool,
  showButton: PropTypes.bool,
  changeListener: PropTypes.func,
  variantId: PropTypes.string,
  defaultQuantity: PropTypes.number,
};

ProductQuantitySelect.defaultProps = {
  items: [],
  showTitle: true,
  showButton: true,
  changeListener: () => {},
  handleKeyDown: () => {},
  variantId: null,
  defaultQuantity: -1,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ProductQuantitySelect);



// WEBPACK FOOTER //
// ./src/Components/ProductQuantitySelect/index.jsx